export default __webpack_public_path__ + "static/media/pensionsdagen2023.8ef4173b.jpg";